// extracted by mini-css-extract-plugin
export default {"Component":"AppLanguages_Component__9k9Xp","Small":"AppLanguages_Small__zKTEt"};